import { useLogin, LOGIN_RESULT } from './Service/useLogin'
import { useDispatch } from 'react-redux'
import { setEvaluations, toggleToAdminUser, toggleToPatientUser, toggleToOphthalmologistUser, toggleToTechnicalUser, updateDataUser, toggleToInstitutionAdminUser } from '../../redux/user'
import { searchAllEvaluations } from '../../views/Evaluations/Service/EvaluationService'
import { getUserData } from './UserData/getUserData'

const TECHNICAL = 'technical'
const PATIENT = 'patient'
const ADMIN = 'admin'
const OPHTHALMOLOGIST = 'ophthalmologist'

const FORMAT_ROLE = {
  tecnico: TECHNICAL,
  retinologo: OPHTHALMOLOGIST,
  paciente: PATIENT,
  admin: ADMIN,
  admin_institucion: 'admin_institucion'
}

export const useValidate = () => {
  const { login } = useLogin()
  const dispatch = useDispatch()

  const validate = async (data) => {
    let result
    try {
      result = await login(data)
    } catch (unexpectedError) {
      return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
    }

    if (!result || !result.type) {
      return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
    }

    if (result.type === LOGIN_RESULT.SUCCESS) {
      try {
        await assignSession(result)
      } catch (sessionError) {
        return { type: LOGIN_RESULT.SERVICE_UNAVAILABLE }
      }
    }

    return result
  }

  const fetchData = async (rol, token, sessionData) => {
    const response = await searchAllEvaluations(token, rol)
    const dataRes = await getUserData(rol, token)
    if (rol === TECHNICAL) {
      dispatch(toggleToTechnicalUser(token))
      dispatch(setEvaluations(response))
      if (sessionData) {
        dispatch(updateDataUser(sessionData))
      }
    }
    if (rol === PATIENT) {
      dispatch(toggleToPatientUser(token))
      dispatch(setEvaluations(response))
      dispatch(updateDataUser(dataRes))
    }
    if (rol === OPHTHALMOLOGIST) {
      dispatch(toggleToOphthalmologistUser(token))
      dispatch(setEvaluations(response))
    }
    if (rol === ADMIN) {
      dispatch(toggleToAdminUser(token))
    }
    if (rol === 'admin_institucion') {
      dispatch(toggleToInstitutionAdminUser(token))
    }
  }

  const assignSession = async (result) => {
    if (!result || result.type !== LOGIN_RESULT.SUCCESS) return

    const role = FORMAT_ROLE[result.rol]

    const userToStore = { role: role, status: null, token: result.token, evaluations: null, data: result.data || null }
    sessionStorage.setItem('_user', JSON.stringify(userToStore))

    await fetchData(role, result.token, result.data)
    window.location = '/home'
  }

  return { validate, assignSession }
}
